import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=52d6b978&scoped=true&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=52d6b978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6b978",
  null
  
)

export default component.exports